import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HONEYPOT_FIELD, honeypotInputProps, ACCOUNT_MAY_EXIST_NOTICE } from '../lib/spam-trap';
import { getStoredRef, clearStoredRef } from '../lib/referral';

export default function Signup() {
  const [form, setForm] = useState(() => ({
    full_name: '', email: '', password: '', referral_code: getStoredRef(), [HONEYPOT_FIELD]: '',
  }));
  const startedAt = useRef(Date.now());
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch('/api/auth/signup', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, form_ms: Date.now() - startedAt.current }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error === 'referral_invalid'
          ? "That referral code isn't valid. Check it, or leave it blank."
          : 'Sign up failed. Check your details.');
        return;
      }
      if (form.referral_code) clearStoredRef();
      if (data.user) {
        localStorage.setItem('learnable_user', JSON.stringify(data.user));
        navigate('/dashboard');
      } else {
        navigate('/login', { state: { notice: ACCOUNT_MAY_EXIST_NOTICE } });
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="max-w-sm mx-auto px-4 py-12 space-y-4">
      <h1 className="text-2xl font-bold">Create your account</h1>
      <input
        {...honeypotInputProps}
        value={form[HONEYPOT_FIELD]}
        onChange={(e) => setForm({ ...form, [HONEYPOT_FIELD]: e.target.value })}
      />
      <input
        required
        placeholder="Full name"
        className="w-full border rounded px-3 py-2"
        value={form.full_name}
        onChange={(e) => setForm({ ...form, full_name: e.target.value })}
      />
      <input
        type="email"
        required
        placeholder="Email"
        className="w-full border rounded px-3 py-2"
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
      />
      <input
        type="password"
        required
        minLength={8}
        placeholder="Password (8+ chars, upper, lower, number)"
        className="w-full border rounded px-3 py-2"
        value={form.password}
        onChange={(e) => setForm({ ...form, password: e.target.value })}
      />
      <div>
        <input
          placeholder="Referral code (optional)"
          className="w-full border rounded px-3 py-2 uppercase placeholder:normal-case"
          maxLength={60}
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          value={form.referral_code}
          onChange={(e) => setForm({ ...form, referral_code: e.target.value.trim() })}
        />
        <p className="text-xs text-slate-500 mt-1">Referred by a friend? Enter their code for 10% off your first course.</p>
      </div>
      {error && <div className="text-sm text-red-600">{error}</div>}
      <button
        disabled={busy}
        className="w-full bg-brand text-white rounded py-2 font-medium disabled:opacity-50"
      >
        {busy ? 'Creating…' : 'Sign up'}
      </button>
    </form>
  );
}
